import { createSelector } from '@reduxjs/toolkit';
import orderBy from 'lodash/orderBy';

import { CORE_MENTEE_MODULE_STATUSES } from '../data/coreMenteModuleStatuses';

const baseSelector = (state) => state.superBatchModule;

export const superBatchModulesSelector = (state) =>
  baseSelector(state).superBatchModules;

export const deleteSuperBatchModuleModalStateSelector = (state) =>
  baseSelector(state).deleteSuperBatchModuleModalState;

export const selectedSuperBatchModuleSelector = (state) =>
  baseSelector(state).selectedSuperBatchModule;

export const updateSuperBatchModuleStatusModalStateSelector = (state) =>
  baseSelector(state).updateSuperBatchModuleStatusModalState;

export const updateSuperBatchModuleIntrviewModalStateSelector = (state) =>
  baseSelector(state).updateSuperBatchModuleIntrviewModalState;

export const addSuperBatchModuleModalStateSelector = (state) =>
  baseSelector(state).addSuperBatchModuleModalState;

export const orderedSuperBatchModulesSelector = createSelector(
  (state) => baseSelector(state).superBatchModules,
  (superBatchModules) => orderBy(superBatchModules, ['order'], ['asc'])
);

export const orderedCoreSuperBatchModulesSelector = createSelector(
  (state) => baseSelector(state).superBatchModules,
  (superBatchModules) =>
    orderBy(superBatchModules, ['order'], ['asc']).filter((superBatchModules) =>
      CORE_MENTEE_MODULE_STATUSES.includes(superBatchModules.status)
    )
);

export const superBatchModuleFieldErrorSelector = (state) =>
  baseSelector(state).superBatchModuleError;
